import React, { useContext } from "react";
import { Field } from "formik";
import { AuthContext } from "../../context/AuthContext";
interface FormikFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  placeholder?: string;
}
const FormikField = ({
  name,
  label,
  placeholder,
  className,
  ...props
}: FormikFieldProps) => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div className="pb-4">
      {label && (
        <label
          htmlFor={name}
          className={`${
            theme === "dark" ? "text-black" : "text-white"
          } transition-all duration-500 block mb-1 text-sm font-medium font-montserrat`}
        >
          {label}
        </label>
      )}
      <Field
        id={name}
        name={name}
        placeholder={placeholder}
        className={`${
          theme === "dark" ? "bg-white text-black" : "bg-transparent border-white/30"
        } transition-all duration-500 w-full px-4 py-3 border-b font-montserrat focus:ring-0 active:ring-0 focus:outline-none focus:ring-blue-500 ${className}`}
        {...props}
      />
    </div>
  );
};
export default FormikField;
